import JSONAsset from './JSONAsset';
import TextAsset from './TextAsset';
import BinaryAsset from './BinaryAsset';
import ImageAsset from './ImageAsset';
import ShaderAsset from './ShaderAsset';
import SceneAsset from './SceneAsset';
import AtlasAsset from './AtlasAsset';
import SoundAsset from './SoundAsset';
import MusicAsset from './MusicAsset';
import ParticleSystemAsset from './ParticleSystemAsset';
import PackAsset from './PackAsset';
import SkeletonAsset from './SkeletonAsset';
import SVGAsset from './SVGAsset';
import SetAsset from './SetAsset';
import AssemblyAsset from './AssemblyAsset';
import PostprocessRackEffectAsset from './PostprocessRackEffectAsset';

export default {
  JSONAsset,
  TextAsset,
  BinaryAsset,
  ImageAsset,
  ShaderAsset,
  SceneAsset,
  AtlasAsset,
  SoundAsset,
  MusicAsset,
  ParticleSystemAsset,
  PackAsset,
  SkeletonAsset,
  SVGAsset,
  SetAsset,
  AssemblyAsset,
  PostprocessRackEffectAsset
};

export {
  JSONAsset,
  TextAsset,
  BinaryAsset,
  ImageAsset,
  ShaderAsset,
  SceneAsset,
  AtlasAsset,
  SoundAsset,
  MusicAsset,
  ParticleSystemAsset,
  PackAsset,
  SkeletonAsset,
  SVGAsset,
  SetAsset,
  AssemblyAsset,
  PostprocessRackEffectAsset
};
